import styles from "./RegistryFooter.module.css";

type RegistryFooterProps = {
  cookiePolicyHref: string;
  privacyPolicyHref: string;
  termsHref: string;
};

function RegistryFooter({
  cookiePolicyHref,
  privacyPolicyHref,
  termsHref,
}: RegistryFooterProps) {
  return (
    <footer className={styles.footer} aria-label="Registry footer">
      <nav className={styles.nav} aria-label="Legal links">
        <a href={cookiePolicyHref} className={styles.link}>
          Cookie policy
        </a>
        <span className={styles.separator} aria-hidden="true">
          |
        </span>
        <a href={privacyPolicyHref} className={styles.link}>
          Privacy policy
        </a>
        <span className={styles.separator} aria-hidden="true">
          |
        </span>
        <a href={termsHref} className={styles.link}>
          Terms &amp; conditions
        </a>
      </nav>
    </footer>
  );
}

export default RegistryFooter;
